import { Fragment } from "react";
import { useTable, usePagination } from "react-table";

const DataTable = ({
  data,
  columns,
  totalCount,
  setCurrentPage,
  currentPage,
}) => {
  const pageOptions = Array.from(
    { length: Math.ceil(totalCount / 10) },
    (_, index) => index
  );

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 10 },
        pageSizeOptions: [10, 20, 50], // Specify available page sizes
      },
      usePagination // Add the usePagination hook
    );

  return (
    <Fragment>
      <div className="table-wrapper m-3">
        <table
          className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.length === 0 ? (
              <tr>
                <td
                  colSpan={headerGroups[0].headers.length}
                  style={{ textAlign: "center", fontWeight: "bold" }}
                >
                  No data available
                </td>
              </tr>
            ) : (
              page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
        <ul
          className="pagination"
          style={{ float: "left", paddingTop: "10px" }}
        >
          {data.length !== 0
            ? pageOptions.map((pageOption, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === index ? "active" : ""
                  }`}
                >
                  <span
                    className="page-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setCurrentPage(index);
                    }}
                  >
                    {pageOption + 1}
                  </span>
                </li>
              ))
            : null}
        </ul>
      </div>
      <div>
        {totalCount > 0 && (
          <p>{`Showing ${currentPage * 10 + 1} to ${
            currentPage * 10 + data.length
          } of ${totalCount} entries`}</p>
        )}
      </div>
    </Fragment>
  );
};

export default DataTable;
